import { ResourceItem } from "./ResourceItem";

export class NameResourceItem extends ResourceItem {
  name!: string;
  constructor(data?: any) {
    super(data);
    if (data) {
      this.name = data.name;
    }
  }
  getPostData() {
    return {
      name: this.name,
    };
  }
}
